import { z } from "zod";
import { cbHttp } from "./http.service";
import { UserSchema } from "@/schemas/user.schema";

export const cbLogin = async (email: string, password: string): Promise<string> => {
    return cbHttp.post('/api/auth/login', { email, password });
}

export const validateToken = async (token: string): Promise<z.infer<typeof UserSchema>> => {
    return cbHttp.get('/api/auth/validate', {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
};

export const getAuthAvailability = async (): Promise<boolean> => {
    return cbHttp.get('/api/auth/authavailability');
}

export const cbChangePassword = async (payload: {
    email: string;
    currentPassword: string;
    newPassword: string;
    confirmPassword: string;
}): Promise<string> => {
    return cbHttp.post('/api/users/change-password', payload);
};